<template>
  <section v-loading.fullscreen.lock="loading" class="helpDto">
    <div v-if="dtoObj">
      <com-dto-data1 :list="helpInfo.obj.basics" :obj="dtoObj" />
      <div class="helpDto-content">
        <el-scrollbar wrap-style="overflow-x: hidden;">
          <div ref="content" class="coontent" v-html="dtoObj.content" />
        </el-scrollbar>
      </div>
    </div>
  </section>
</template>

<script>
import mock from '@/utils/mock'
import comDtoData1 from './comDtoData1.vue'
export default {
  components: {
    comDtoData1
  },
  data() {
    return {
      helpInfo: mock.notes.help.viewInfo,
      helpInit: mock.notes.help.init,
      dtoObj: null,
      requestParams1: {
        id: null
      },
      loading: false
    }
  },
  computed: {},
  watch: {
    $route: {
      handler(v) {
        this.init(v.query.id)
      }
    },
    deep: true
  },
  created() {
    this.loading = true
    this.init()
  },
  mounted() {
  },
  methods: {
    init() {
      this.requestParams1.id = this.$route.query.id
      this.initDto(this.requestParams1)
    },
    async initDto(v) {
      this.dtoObj = await this.helpInit.dto(v)

      setTimeout(this.getParent, 300)
    },
    getParent() {
      if (this.dtoObj.content.indexOf('video') != -1) {
        var vj = document.querySelector('.video-js').parentNode
        if (vj.getAttribute('style') == 'text-align: center;') {
          vj.children[0].setAttribute('style', 'margin: 0 auto;')
        } else if (vj.getAttribute('style') == 'text-align: left;') {
          vj.children[0].setAttribute('style', 'float: left;')
        } else if (vj.getAttribute('style') == 'text-align: right;') {
          vj.children[0].setAttribute('style', 'float: right;')
        }
      }

      this.loading = false
    },
    control(type, condition) {
      return mock.system.global.control[type](condition)
    }
  }
}
</script>
<style lang='scss' scoped>
.coontent{
  padding-bottom: 50px;
  font-size: 16px;
  color: #333;
  font-family: '微软雅黑';
  line-height: 36px;
}
.helpDto {
  @include fun-layout(1);
  min-width: $xr-min-width;
  > div {
    height: 100%;
    margin: 0 auto;
    width: 100%;
  }
  &-content {
    height: calc(100% - 106px);
    @include fun-layout(2);
    margin-top: 20px;
    padding:40px 80px;
  }
}
</style>
